import { render } from "./WorksSection.vue?vue&type=template&id=00d2272c&scoped=true"
import script from "./WorksSection.vue?vue&type=script&lang=js"
export * from "./WorksSection.vue?vue&type=script&lang=js"

import "./WorksSection.vue?vue&type=style&index=0&id=00d2272c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d2272c"]])

export default __exports__